import { useMemo } from "react";
import { Header } from "@sablier/v2-components/molecules";
import { useT } from "@sablier/v2-locales";
import { _ } from "@sablier/v2-mixins";
import { tabs } from "~/client/constants";
import { useDashboardTab } from "~/client/hooks";

function Top() {
  const { t } = useT();
  const { tab } = useDashboardTab();

  const title = useMemo(() => {
    switch (tab?.identifier) {
      case tabs.dashboard.search.identifier:
        return _.startCase(t("structs.filteredStreams"));
      case tabs.dashboard.recipient.identifier:
        return _.startCase(t("structs.incomingStreams"));
      case tabs.dashboard.sender.identifier:
        return _.startCase(t("structs.outgoingStreams"));
      case tabs.dashboard.all.identifier:
      default:
        return _.startCase(t("structs.allStreams"));
    }
  }, [tab, t]);

  return <Header title={title} titleShort={_.capitalize(t("words.streams"))} />;
}

export default Top;
